import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import VideoPlayer from "./VideoPlayer";
import { subscribersAPI } from "../../services/api";
import { Container, Form, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaWater, FaPlay } from "react-icons/fa";
import { PiMountains } from "react-icons/pi";
import { BsTree } from "react-icons/bs";
import { VscCompass } from "react-icons/vsc";

import "./Hero.css";
import CircularBadge from "../badge";

const HEADLINE = ["Dare", "to", "Live", "Again"];
const RAIL_ICONS = [PiMountains, BsTree, FaWater, VscCompass];

const ease = [0.22, 1, 0.36, 1];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09, delayChildren: 0.15 } },
};
const lineUp = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 0.85, ease } },
};
const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease } },
};

export default function Hero() {
  const [email, setEmail]           = useState("");
  const [videoOpen, setVideoOpen]   = useState(false);
  const [videoFromUrl, setVideoFromUrl] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  // Open player when URL contains ?forgeintro
  useEffect(() => {
    if (searchParams.has("forgeintro")) {
      setVideoFromUrl(true);
      setVideoOpen(true);
    }
  }, [searchParams]);

  const openVideo = () => {
    setVideoFromUrl(false);
    setVideoOpen(true);
    // Add param to URL so it can be shared / deep-linked
    setSearchParams({ forgeintro: "" }, { replace: true });
  };

  const closeVideo = () => {
    setVideoOpen(false);
    setVideoFromUrl(false);
    // Remove the param from URL
    setSearchParams({}, { replace: true });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await subscribersAPI.subscribe(email, "Hero");
      setEmail("");
    } catch (err) {
      console.error("Subscribe error:", err.message);
    }
  };

  return (
    <section className="hero" id="top">
      {/* Background image + fade-to-cream scrim */}
      <div className="hero__media" aria-hidden="true">
        <motion.img src={"./assets/hero.png"} alt="" className="hero__img" initial={{ scale: 1.08, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 1.6, ease }} />
        <div className="hero__scrim" />
      </div>

      <div className="position-absolute " style={{ top: "10%", right: "20%" }}>
        <CircularBadge colors="var(--c-rust)" />
      </div>

      <Container fluid="xl" className="hero__inner container-fg container-2xxl">
        {/* Left index rail */}
        <motion.aside className="hero__rail" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, delay: 0.5, ease }} aria-hidden="true">
          <span className="hero__rail-num">01</span>
          <span className="hero__rail-line" />
          <ul className="hero__rail-icons">
            {RAIL_ICONS.map((Icon, i) => (
              <li key={i}>
                <Icon />
                <span className={`hero__rail-line ${i === RAIL_ICONS.length - 1 ? "" : "alt"}`} />
              </li>
            ))}
          </ul>
        </motion.aside>

        {/* Headline + copy + capture */}
        <div className="hero__content">
          <motion.h1 className="hero__title u-display" variants={container} initial="hidden" animate="show">
            {HEADLINE.map((line, i) => (
              <span className="hero__line" key={i} style={{ color: i === 1 ? "var(--accent)" : "" }}>
                <motion.span className="hero__line-inner" variants={lineUp}>
                  {line}
                </motion.span>
              </span>
            ))}
          </motion.h1>

          <motion.p className="hero__sub" variants={fadeUp} initial="hidden" animate="show" transition={{ delay: 0.6 }}>
            7 days in nature.
            <br />A lifetime of purpose.
          </motion.p>

          <motion.div variants={fadeUp} initial="hidden" animate="show" transition={{ delay: 0.75 }}>
            <Form className="hero__form" onSubmit={handleSubmit}>
              <Form.Label htmlFor="hero-email" className="visually-hidden">
                Email address
              </Form.Label>
              <Form.Control id="hero-email" type="email" inputMode="email" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} className="hero__input" required />
              <Button type="submit" className="hero__cta">
                Get Retreat Info
              </Button>
            </Form>
          </motion.div>
        </div>

        {/* Watch the film */}
        <motion.button type="button" className="hero__film" onClick={openVideo} aria-label="Watch the Forge Retreat film" initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 1, ease }}>
          <span className="hero__film-play">
            <FaPlay />
          </span>
          <span className="hero__film-label">Watch the Film</span>
        </motion.button>
      </Container>

      <div className="clouds">
        <img src="./assets/image.png" alt="" />
        <img src="./assets/image.png" alt="" className="cloud-flip" />
      </div>
      {/* ── Video player ── */}
      <AnimatePresence>
        {videoOpen && <VideoPlayer onClose={closeVideo} fromUrl={videoFromUrl} />}
      </AnimatePresence>
    </section>
  );
}
